import styled, { css } from "styled-components";
import { propStyling, tombac } from "../../../shared";
import { Container } from "./Container";
export const Label = styled.span.withConfig({
  displayName: "Label"
})(["", ""], _ref => {
  var _hover, _disabled;
  let {
    theme: {
      components: {
        button: {
          current
        }
      }
    }
  } = _ref;
  return css(["all:initial;cursor:inherit;margin:", ";transition:0.1s ease-out;transition-property:color,opacity;white-space:nowrap;z-index:1;", " ", ":hover &&{color:", ";}", ":disabled &&{color:", ";}", ""], _ref2 => {
    let {
      withAddon
    } = _ref2;
    return tombac.space(0, withAddon ? 1 : 0);
  }, tombac.altText({
    color: tombac.parse(current.color),
    fontSize: current.fontSize,
    fontWeight: 700
  }), Container, tombac.parse((_hover = current.hover) === null || _hover === void 0 ? void 0 : _hover.color), Container, tombac.parse((_disabled = current.disabled) === null || _disabled === void 0 ? void 0 : _disabled.color), propStyling);
});
//# sourceMappingURL=Label.js.map